// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes S98pulxMdcJWVhnR8FIX {
    0%{
        background-position: -100vw 0
    }

    100%{
        background-position: 100vw 0
    }
}

.vGW6OPYIOXWU7SutxTXA {
    margin-bottom: 16px;
    line-height: 1.5;
    border-bottom: 1px solid #ddd;
}

.eK1k7DUHBWGpfeZq1jW_ > tbody > tr > td {
    vertical-align: middle;
}

.S98pulxMdcJWVhnR8FIX {
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: S98pulxMdcJWVhnR8FIX;
    animation-timing-function: linear;
    background: linear-gradient(to right, white 8%, #dddddd 18%, white 33%);
    background-size: 100vw 1px;
}

.ejdQV9nPwmmth2MMxIbK {
    display: block;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.K43RinZ9A6T816Bh0bzg {
    font-size: 12px;
}

.ylLCrEEwGM4F7yMEM6Aq {
    display: flex;
    align-items: center;
}

.cHjIu4p3zP7jbXHZIK0A {
    margin-left: auto;
}

.uHLHHhOBuLl2GeHyAKJV {
    text-align: center;
    font-size: 16px;
    line-height: 2;
}

.iquNXR7JtygKdlf03ERc {
    background-color: white;
    color: #2EB6C8;
}

.MUB7A5d37_WBkYQkpQuE {
    margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-documents/components/index.module.css"],"names":[],"mappings":"AAAA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,mCAAmC;IACnC,oCAAuB;IACvB,iCAAiC;IACjC,uEAAuE;IACvE,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["@keyframes shimmer {\n    0%{\n        background-position: -100vw 0\n    }\n\n    100%{\n        background-position: 100vw 0\n    }\n}\n\n.heading {\n    margin-bottom: 16px;\n    line-height: 1.5;\n    border-bottom: 1px solid #ddd;\n}\n\n.table > tbody > tr > td {\n    vertical-align: middle;\n}\n\n.shimmer {\n    animation-duration: 2s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: shimmer;\n    animation-timing-function: linear;\n    background: linear-gradient(to right, white 8%, #dddddd 18%, white 33%);\n    background-size: 100vw 1px;\n}\n\n.filename {\n    display: block;\n    max-width: 220px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.detail {\n    font-size: 12px;\n}\n\n.actions {\n    display: flex;\n    align-items: center;\n}\n\n.submit {\n    margin-left: auto;\n}\n\n.help {\n    text-align: center;\n    font-size: 16px;\n    line-height: 2;\n}\n\n.badge {\n    background-color: white;\n    color: #2EB6C8;\n}\n\n.rules {\n    margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `vGW6OPYIOXWU7SutxTXA`,
	"table": `eK1k7DUHBWGpfeZq1jW_`,
	"shimmer": `S98pulxMdcJWVhnR8FIX`,
	"filename": `ejdQV9nPwmmth2MMxIbK`,
	"detail": `K43RinZ9A6T816Bh0bzg`,
	"actions": `ylLCrEEwGM4F7yMEM6Aq`,
	"submit": `cHjIu4p3zP7jbXHZIK0A`,
	"help": `uHLHHhOBuLl2GeHyAKJV`,
	"badge": `iquNXR7JtygKdlf03ERc`,
	"rules": `MUB7A5d37_WBkYQkpQuE`
};
export default ___CSS_LOADER_EXPORT___;
